import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { TableLineageCountsFragmentGql } from './TableLineageCountsFragmentGql';

export const TableLineageCountsQueryGql: DocumentNode = gql`
query TableLineageCountsQuery($tableId: ID!, $publishedConnectionsLineageEnabled: Boolean!) {
  tables(filter: { id: $tableId }) {
    ...TableLineageCountsFragment
  }
}
${TableLineageCountsFragmentGql}
`;
